import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentForm: 'init',
    isBillingSubmitted: false,
    cartItems: [],
    showCart: false,
    showSearchAndNewspaperList: true,
    imdaRef: '',
    paymentDetails: {
        netsTxnRef: '',
        netsTxnDtm: '',
        paymentMode: ''
    },
    myInfo: null
};

const newspaperRegisterSlice = createSlice({
    name: 'newpaperRegister',
    initialState,
    reducers: {
        setCurrentForm(state, action) {
            state.currentForm = action.payload;
        },
        setIsBillingSubmitted(state, action) {
            state.isBillingSubmitted = action.payload;
        },
        setCartItems(state, action) {
            state.cartItems = action.payload;

            if (state.cartItems.length <= 0) {
                state.showCart = false;
                state.showSearchAndNewspaperList = true;
            }
        },
        setShowCart(state, action) {
            state.showCart = action.payload;
        },
        setShowSearchAndNewspaperList(state, action) {
            state.showSearchAndNewspaperList = action.payload;
        },
        setMyinfo(state, action) {
            state.myInfo = action.payload;
        },
        setImdaRef(state, action) {
            state.imdaRef = action.payload || '';
        },
        setPayment(state, action) {
            const { netsTxnRef = '', netsTxnDtm = '', paymentMode = '' } = action.payload;
            state.paymentDetails = {
                netsTxnRef,
                netsTxnDtm,
                paymentMode
            };
        },
        resetNewspaperRegisterState(state) {
            state.showCart = false;
            state.showSearchAndNewspaperList = true;
            state.myInfo = null;
            state.cartItems = [];
        }
    }
});

export const {
    setCurrentForm,
    setIsBillingSubmitted,
    setCartItems,
    setShowCart,
    setShowSearchAndNewspaperList,
    setMyinfo,
    setImdaRef,
    setPayment,
    resetNewspaperRegisterState
} = newspaperRegisterSlice.actions;

export default newspaperRegisterSlice.reducer;
